export default __webpack_public_path__ + "static/media/right section.ad78fcd2.png";